// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPaletteSetting.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'share/enhancers/Izenda.Connect';
import ColorPalette from './Izenda.ColorPalette';
import actions from './Izenda.ColorPaletteSettingActions';
import Button from 'share/components/controls/Izenda.Button';
import { isUndefined } from 'lodash/fp';

/**
 * Color Palette Setting component
 */
@connect(actions)
export default class ColorPaletteSetting extends Component {
  static propsType = {
    selectedPaletteName: PropTypes.string,
    resetDefaultValue: PropTypes.func,
    displaySettingStatus: PropTypes.bool,
    selectionPopupTitle: PropTypes.string,
    updateSelectedPalette: PropTypes.func,
    needMaskDefault: PropTypes.bool
  };

  renderGearIcon = (isDefaultTheme: boolean) => {
    const { localization, displaySettingStatus } = this.props;
    const displayIcon = displaySettingStatus && !isDefaultTheme;

    return (
      <div className="izenda-ColorPalette-GearIcon">
        <Button
          className="btn btn-primary btn-icon icon-setting"
          onClick={this.props.showColorPaletteSelectionPopup}
          title={localization.getText('COLORTHEME_OPTION_TOOLTIP')}
        >
          {displayIcon && (
            <div className="u_floatRight u-posRelative">
              <i className="icon-ok u_smallIcon u-hadSetting u-colorWhite u-bgGreen" />
            </div>
          )}
        </Button>
        {displayIcon && (
          <span>
            <i
              className="icon-cancel u-colorRed"
              title={localization.getText('PROPERTIES_EDITOR_REMOVE_SETTING')}
              onClick={this.props.resetDefaultValue}
            />
          </span>
        )}
      </div>
    );
  };

  componentDidMount() {
    this.props.init(this.props);
  }

  render() {
    const { store, selectedPaletteName, displaySettingStatus, value = {} } = this.props;
    const paletteName = isUndefined(selectedPaletteName) ? value.colorPalette : selectedPaletteName;
    if (store.palettes.length === 0) {
      return null;
    }

    const model = store.getColorPaletteDetail(paletteName);
    const isDefaultTheme = isUndefined(value.isDefaultTheme) ? model.isDefaultTheme: value.isDefaultTheme;

    return (
      <div className="izenda-ColorPaletteSetting">
        <ColorPalette model={model} isDefaultTheme={isDefaultTheme} displaySettingStatus={displaySettingStatus} />
        {this.renderGearIcon(isDefaultTheme)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/ColorPalette/Izenda.ColorPaletteSetting.js